import LogIn from '@/components/Auth/Login'

const LoginScreen = () => {
  return <LogIn />
}

export default LoginScreen
